import React, { useEffect, useState } from "react";
// import Header from "../components/dashboard/header";
import Header from "./Header";
import Footer from "./Footer";
import doctorTab from "../assets/images/doctor-tab.svg";
import calenderIcon from "../assets/images/blank-notepad--content-notes-book-notepad-notebook.svg";
import circleClock from "../assets/images/circle-clock--clock-loading-measure-time-circle.svg";
import { useNavigate, Link } from "react-router-dom";
import tmdbApi from "../api/tmdbApi";
// import launchImage from '../assets/images/launch.svg';
import CPCBlock from "./quiz/CPCBlock";
import docUser from "../assets/images/doc-user.png";
import businessdeal from "../assets/images/business-handshake--deal-contract-business-money-payment-agreement.svg";
// import calendar from "../assets/images/icons/calendar.svg";
// import clockIcon from "../assets/images/icons/clock.svg";
import gobalLearning from "../assets/images/icons/Global-Learning-.svg";
import eyeOptic from "../assets/images/icons/Eye-Optic.svg";
import groupMeeting from "../assets/images/icons/Group-Meeting.svg";
import definitionSearch from "../assets/images/icons/Definition-Search.svg";
import calendarEdit from "../assets/images/icons/Calendar-Edit.svg";
import globalLearningbig from "../assets/images/icons/Global-Learning.svg"
import desktopFav from "../assets/images/icons/Desktop-Dollar.svg"
import chatTwo from "../assets/images/icons/Chat-Two.svg"
import leactureModule from '../assets/images/Lecture-Module.svg';
import sessionbg from '../assets/images/session-bg.svg';
// import launchImg from '../assets/images/icons/launch-img.svg';
import reporting from '../assets/images/icons/reporting-icon.svg';
import learningIcon from '../assets/images/icons/learning-icon.svg';
import sasiKiran from '../assets/images/Dr.Sasi-Kiran-Attili.svg';
import nandaKumar from '../assets/images/Dr.G.Nandakumar.svg';
import manojSingh from '../assets/images/Dr.Manoj.svg';
import clockIcon from "../assets/images/icons/cpc-clock.svg";
import calendar from "../assets/images/icons/cpc-calendar.svg";
import SessionPopup from "./SessionPopup";





const CpcRegistration = () => {
    const navigate = useNavigate();
    const [quizInfo, setQuizInfo] = useState(null)
    const [isEnabled, setIsEnabled] = useState(false);

    const [showSessionPopupup, setShowSessionPopupup] = useState(false);

    let token = localStorage.getItem("token")

    useEffect(() => {
        // Apply background on mount
        document.body.style.background = '#FFFFFF';

        // Optional: Cleanup (revert background when component unmounts)
        return () => {
            document.body.style.background = null;
        };
    }, []);

    const checkIfExpired = (dateStr, timeStr) => {
        // Parse date and time
        const [year, month, day] = dateStr.split("-").map(Number);
        const [hour, minute] = timeStr.split(":").map(Number);

        // Create Date object assuming IST (UTC+5:30)
        const utcEnd = new Date(Date.UTC(year, month - 1, day, hour - 5, minute - 30));

        // Current time in UTC
        const nowUTC = new Date();

        return nowUTC > utcEnd;
    };


    const getCpcInfo = async () => {
        const response = await tmdbApi.cpcInfo("");

        if (
            response?.result == "Invalid token or Expired" &&
            response?.statusCode === 200
        ) {
            setShowSessionPopupup(true);

        } else if (response?.result?.length > 0) {
            setQuizInfo(response?.result[0])
        }


    }

    useEffect(() => {
        if (quizInfo) {
            const checkTime = () => {
                if (!quizInfo?.scheduleate || !quizInfo?.liveStartTime || !quizInfo?.liveEndTime) return;

                const [year, month, day] = quizInfo.scheduleate.split("-").map(Number);
                const [startHour, startMinute] = quizInfo.liveStartTime.split(":").map(Number);
                const [endHour, endMinute] = quizInfo.liveEndTime.split(":").map(Number);

                // Create Date objects in IST timezone
                const toDateInIST = (h, m) => {
                    // Create a date object in local time, then shift by IST offset
                    const localDate = new Date(Date.UTC(year, month - 1, day, h - 5, m - 30));
                    return localDate;
                };

                const startTime = toDateInIST(startHour, startMinute);
                const endTime = toDateInIST(endHour, endMinute);

                const now = new Date();

                setIsEnabled(now >= startTime && now <= endTime);
            };

            checkTime(); // Initial check
            const interval = setInterval(checkTime, 30000); // Re-check every 30 seconds

            return () => clearInterval(interval);
        }
    }, [quizInfo]);
    const [winners, setWinners] = useState([]);
    const fetchWinners = async () => {
        try {
            const response = await tmdbApi.latestCpcTopWinners()
            if (typeof response?.result !== 'string') {
                console.log("response", response?.result)
                setWinners(response.result);
            }
        } catch (error) {
            console.error('Error fetching winners:', error);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        getCpcInfo()
        fetchWinners();
    }, []);
    const handelnavigation = (userType) => {
        localStorage.setItem('userType', userType)
        navigate("/signup")
    }

    const join = () => {
        if (isEnabled) {
            window.open(quizInfo?.meetingLink, '_blank');
        } else {
            navToQuiz();
        }
    }

    const login = () => {
        if (token) {
            navigate("/studentcpc")

        } else {
            localStorage.setItem('userType', "STUDENT")
            localStorage.setItem("cpcid", quizInfo?.cpcid)

            navigate("/login")
        }


    }

    const displayDate = (date) => {
        const formattedDate = new Date(date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
        return formattedDate;

    }

    const convertToAMPM = (time24) => {
        const [hour, minute] = time24.split(":").map(Number);
        const date = new Date();
        date.setHours(hour);
        date.setMinutes(minute);

        return date.toLocaleTimeString('en-IN', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };

    const handleEmail = () => {
        navigate("/contact")
    }

    const handleClick = () => {
        navigate("/Pathologic-Correlation")
    }
    const navToQuiz = async () => {

        const response = await tmdbApi.quizInfoId(quizInfo.quizId);
        if (response?.result) {
            let data = response.result[0];
            localStorage.setItem('q', JSON.stringify(data))

            navigate({
                pathname: "/quiz",
                state: { data }
            });
        }

    }
    const cpcScheduleSection = () => {
        quizInfo && <section className="why-join cpc-sche-section pt-5 pb-5">
            <div className="row justify-content-center align-items-center">
                <div className="text-center mb-3">
                    <h3>CPC Schedule</h3>
                </div>
                <div className="d-flex flex-wrap col-lg-12 justify-content-center cpc-sech-point-resp gap-1" id="why-join-dadi-resp">

                    {/* <div className="col-lg-8 pt-4 pb-4 col-md-12 col-sm-12 feature-item why-cpc-item">
                               
                                <div className="feature-text d-flex align-items-start gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" className="mt-1" id="Information-Circle--Streamline-Core-Neon" height="14" width="14">
                                        <g id="information-circle--information-frame-info-more-help-point-circle">
                                            <path id="Vector" stroke="#215250" stroke-linecap="round" stroke-linejoin="round" d="M7 13.5c3.5899 0 6.5 -2.9101 6.5 -6.5C13.5 3.41015 10.5899 0.5 7 0.5 3.41015 0.5 0.5 3.41015 0.5 7c0 3.5899 2.91015 6.5 6.5 6.5Z" stroke-width="1"></path>
                                            <path id="Vector_2" stroke="#ea7f4a" stroke-linecap="round" stroke-linejoin="round" d="M5.5 10h3" stroke-width="1"></path>
                                            <path id="Vector_3" stroke="#ea7f4a" stroke-linecap="round" stroke-linejoin="round" d="M7 10V6.5H6" stroke-width="1"></path>
                                            <g id="Group 2605">
                                                <path id="Ellipse 1111" stroke="#ea7f4a" stroke-linecap="round" stroke-linejoin="round" d="M7 4.25c-0.13807 0 -0.25 -0.11193 -0.25 -0.25s0.11193 -0.25 0.25 -0.25" stroke-width="1"></path>
                                                <path id="Ellipse 1112" stroke="#ea7f4a" stroke-linecap="round" stroke-linejoin="round" d="M7 4.25c0.13807 0 0.25 -0.11193 0.25 -0.25s-0.11193 -0.25 -0.25 -0.25" stroke-width="1"></path>
                                            </g>
                                        </g>
                                    </svg>
                                    <div>
                                        <b>Free Inaugural Session</b>
                                        <p className="mt-1 mb-0"><span className="cpc-schedule">June 25, 2025, 3:30–4:30 PM IST </span>
                                            – Kick off with a live CPC on Zoom!</p>
                                    </div>
                                </div>
                            </div> */}

                    <div className="col-lg-8 pt-4 pb-4 col-md-12 col-sm-12 feature-item why-cpc-item">
                        {/* <img
                                    src={desktopFav}
                                    alt="Icon"
                                    className="feature-icon mb-3"
                                /> */}
                        <div className="feature-text d-flex align-items-start gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" className="mt-1" id="Information-Circle--Streamline-Core-Neon" height="14" width="14">
                                <g id="information-circle--information-frame-info-more-help-point-circle">
                                    <path id="Vector" stroke="#215250" stroke-linecap="round" stroke-linejoin="round" d="M7 13.5c3.5899 0 6.5 -2.9101 6.5 -6.5C13.5 3.41015 10.5899 0.5 7 0.5 3.41015 0.5 0.5 3.41015 0.5 7c0 3.5899 2.91015 6.5 6.5 6.5Z" stroke-width="1"></path>
                                    <path id="Vector_2" stroke="#ea7f4a" stroke-linecap="round" stroke-linejoin="round" d="M5.5 10h3" stroke-width="1"></path>
                                    <path id="Vector_3" stroke="#ea7f4a" stroke-linecap="round" stroke-linejoin="round" d="M7 10V6.5H6" stroke-width="1"></path>
                                    <g id="Group 2605">
                                        <path id="Ellipse 1111" stroke="#ea7f4a" stroke-linecap="round" stroke-linejoin="round" d="M7 4.25c-0.13807 0 -0.25 -0.11193 -0.25 -0.25s0.11193 -0.25 0.25 -0.25" stroke-width="1"></path>
                                        <path id="Ellipse 1112" stroke="#ea7f4a" stroke-linecap="round" stroke-linejoin="round" d="M7 4.25c0.13807 0 0.25 -0.11193 0.25 -0.25s-0.11193 -0.25 -0.25 -0.25" stroke-width="1"></path>
                                    </g>
                                </g>
                            </svg>
                            <div>
                                <b>Free Monthly CPCs</b>
                                <p className="mt-1 mb-0">Sessions every <span className="cpc-schedule">First Sunday of every month</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8 pt-4 pb-4 col-md-12 col-sm-12  feature-item why-cpc-item">
                        {/* <img
                                    src={globalLearningbig}
                                    alt="Icon"
                                    className="feature-icon mb-3"
                                /> */}

                        <div className="feature-text d-flex align-items-start gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" className="mt-1" id="Information-Circle--Streamline-Core-Neon" height="14" width="14">
                                <g id="information-circle--information-frame-info-more-help-point-circle">
                                    <path id="Vector" stroke="#215250" stroke-linecap="round" stroke-linejoin="round" d="M7 13.5c3.5899 0 6.5 -2.9101 6.5 -6.5C13.5 3.41015 10.5899 0.5 7 0.5 3.41015 0.5 0.5 3.41015 0.5 7c0 3.5899 2.91015 6.5 6.5 6.5Z" stroke-width="1"></path>
                                    <path id="Vector_2" stroke="#ea7f4a" stroke-linecap="round" stroke-linejoin="round" d="M5.5 10h3" stroke-width="1"></path>
                                    <path id="Vector_3" stroke="#ea7f4a" stroke-linecap="round" stroke-linejoin="round" d="M7 10V6.5H6" stroke-width="1"></path>
                                    <g id="Group 2605">
                                        <path id="Ellipse 1111" stroke="#ea7f4a" stroke-linecap="round" stroke-linejoin="round" d="M7 4.25c-0.13807 0 -0.25 -0.11193 -0.25 -0.25s0.11193 -0.25 0.25 -0.25" stroke-width="1"></path>
                                        <path id="Ellipse 1112" stroke="#ea7f4a" stroke-linecap="round" stroke-linejoin="round" d="M7 4.25c0.13807 0 0.25 -0.11193 0.25 -0.25s-0.11193 -0.25 -0.25 -0.25" stroke-width="1"></path>
                                    </g>
                                </g>
                            </svg>
                            <div>
                                <b>Pre-CPC Quiz</b>
                                <p className="mt-1 mb-0">Join the “DADI Dermpath Challenge: Pre-CPC Quiz of the Month” to gear up
                                    for each session. The first quiz is<span className="cpc-schedule"> free </span> (June 2025), with subsequent quizzes at INR 500/quiz. The winner receives <span className="cpc-schedule">
                                        INR 5000 worth of modules access </span>as a prize!</p>
                            </div>
                        </div>
                    </div>
                    {/* </div> */}
                </div>
            </div>
        </section>
    }
    return (
        <>

            <Header />
            {showSessionPopupup && <SessionPopup />}
            <style>
                {`
                body{
                    background: #FFFFFF !important;}
                }`}
            </style>

            <div className="cpc-bg cpc-registration">

                {/* <section className="about-us-section text-center bg-light">
                    <div className="container">
                        <h3 className="txt-48">CPC</h3>
                        <p className="txt-16 text-muted cpc-head-para">Clinical insights. Pathological clarity. Collaborative learning. Empowering medical professionals <br></br> for accurate diagnoses and better patient outcomes worldwide.</p>
                    </div>
                </section> */}


                {/* 
                <div className="row container-fluid gap-5 cpc-table cpc-page mt-5 mb-5" id="cpc-table">

                    {doctorTab && <CPCBlock img={doctorTab} table={true} />}
                   
                </div> */}
                <section className="offer-banner pt-5 pb-5">
                    <div className="container text-light text-center">
                        <h3 className="txt-48 fw-bold">Clinico-Pathological Conferences</h3>
                        <p className="txt-16 text-light cpc-head-para">Clinical insights. Pathological clarity. Collaborative learning. Empowering medical professionals <br></br> for accurate diagnoses and better patient outcomes worldwide.</p>
                    </div>
                    {/* <!-- ORANGE STRIP (50 % OFF) --> */}
                    {/* <div
                        className="offer-strip rounded-3 shadow-sm d-flex flex-column justify-content-center px-3 py-3 mt-1 mb-4 ps-5 pe-5"
                    >

                        <span className="highlight fw-bold">
                            Win INR 5000 Worth of Modules Access in Our Pre-CPC Quiz!
                        </span>
                        <p className="txt-16 text-light text-center fw-semibold cpc-head-para mb-0">Register for our Free CPC Event - Learn, Quiz & Connect</p>

                    </div> */}
                    {/* <div>
                        <h4 className="offer-headline mb-1">
                            Elevate Your Dermatopathology Skills with India’s Best!
                        </h4>
                    </div> */}
                    {/* <div className="mb-0 text-light">
                     <h4 className="offer-headline txt-48 fw-semibold mb-1">
                            Launch CPC Session
                        </h4> 
                        <p className="txt-16 text-light fw-semibold cpc-head-para">Register for our Free CPC Event - Learn, Quiz & Connect</p> 
                        <h5 className="offer-headline fw-normal fs-6 mb-3">No registration fee. No strings. Just learning.</h5> 
                    </div> */}
                    <div className="col-lg-12 mt-3 row justify-content-center">
                        <CPCBlock timer={true} />


                    </div>


                </section>

                {/* {cpcScheduleSection()} */}

                <section className=" mt-5 mb-5 ">
                    <div className="container">
                        <div className="text-center mb-4">
                            <h3>Why Join DADI CPCs?</h3>
                            <p className="mt-3">
                                Experience transformative dermatopathology education with DADI
                                <br />
                                (Dermpath Academy and Diagnostics India Pvt Ltd). Our free monthly CPCs offer
                            </p>
                        </div>
                        <div className="d-flex flex-wrap col-lg-12 justify-content-center why-join-resp ms-4 mb-5 gap-3" id="why-join-dadi-resp">
                            <div className="col-lg-3 col-md-4 col-sm-5 feature-item why-cpc-item">
                                <img
                                    src={chatTwo}
                                    alt="Icon"
                                    className="feature-icon mb-3"
                                />
                                <div className="feature-text">
                                    <b>Complex Case Discussions</b>
                                    <p className="mt-1 mb-0">Analyze real cases with scanned slides, led by top experts.</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-4 col-sm-5 feature-item why-cpc-item">
                                <img
                                    src={desktopFav}
                                    alt="Icon"
                                    className="feature-icon mb-3"
                                />
                                <div className="feature-text">
                                    <b>Interactive Quizzes</b>
                                    <p className="mt-1 mb-0">Test your knowledge and win exciting prizes.</p>
                                </div>
                            </div>


                            <div className="col-lg-3 col-md-4 col-sm-5 feature-item why-cpc-item">
                                <img
                                    src={globalLearningbig}
                                    alt="Icon"
                                    className="feature-icon mb-3"
                                />
                                <div className="feature-text">
                                    <b>Global Community</b>
                                    <p className="mt-1 mb-0">Connect with India’s dermatology elite via Zoom.</p>
                                </div>
                            </div>
                        </div>






                    </div>


                </section>

                <section className=" mt-5 why-join pt-5 pb-5">
                    <div className="container-fluid">
                        <div className="text-center mb-4">
                            <h3>Meet Your CPC Leaders</h3>
                        </div>

                        <div className="row meet-your-resp justify-content-center mt-3 gap-3">
                            <div className="p-4 pb-3 text-center feature-item why-cpc-item why-cpc-item1 doc-user">
                                <img
                                    src={sasiKiran}
                                    alt="Icon"
                                    className="feature-icon mb-3"
                                />
                                <div className="feature-text">
                                    <b>Dr. Sasi Kiran Attili</b>
                                    <h6 className="about-us-team-sub-head mb-2 mt-2">
                                        Academic & Mentorship Leadership
                                    </h6>
                                  <div className="text-start mt-3">
                                      <div>
                                        <ul className="team-list">
                                            <li className="fw-bold">MRCP (Dermatology, UK); ICDP–UEMS   </li>
                                            <li className="fw-bold">Consultant Dermatologist & Dermatopathologist </li>
                                            <li className="fw-bold">Editor-in-Chief, Indian Journal of Dermatopathology & Diagnostic Dermatology  </li>
                                        </ul>
                                    </div>
                                    <h6 className="mb-2">
                                        UK-trained dermatologist–dermatopathologist with a strong academic focus on clinicopathological correlation and diagnostic reasoning.
                                    </h6>
                                    <div>
                                        <ul className="team-list">
                                            <li>Delivered 150+ national and international academic presentations  </li>
                                            <li>Developed structured dermatopathology teaching frameworks </li>
                                            <li>Initiated national quiz programmes and digital CPC platforms  </li>
                                            <li>Leads digital architecture, website development, and institutional partnerships for DADI  </li>
                                        </ul>
                                    </div>
                                  </div>
                                </div>
                            </div>

                            <div className="p-4 pb-3 text-center feature-item why-cpc-item why-cpc-item1 doc-user">
                                <img
                                    src={nandaKumar}
                                    alt="Icon"
                                    className="feature-icon mb-3"
                                />
                                <div className="feature-text">
                                    <b>Dr. G. Nandakumar</b>
                                    <h6 className="about-us-team-sub-head mb-2  mt-2">
                                        Clinical & Teaching Leadership
                                    </h6>
                                    <div className="text-start mt-3">

                                        <div>
                                            <ul className="team-list">
                                                <li className="fw-bold">MD (D&V); MD (Pathology) </li>
                                                <li className="fw-bold">Former Principal & Head, Department of Pathology, Government Medical College, Trivandrum  </li>
                                                <li className="fw-bold">Senior Consultant, Dermatology & Dermatopathology, Cosmopolitan Hospital, Trivandrum, Kerala </li>
                                                <li className="fw-bold">Recipient, IADVL Best Teacher Award (2024)  </li>
                                            </ul>
                                        </div>
                                        <h6 className="mb-2">
                                            Uniquely dual-trained dermatologist and pathologist with a distinguished academic career.
                                        </h6>
                                        <div>
                                            <ul className="team-list">
                                                <li>Widely respected for postgraduate teaching and clinicopathological correlation </li>
                                                <li>Academic interests include inflammatory dermatoses, adnexal tumours, and dermatopathology education   </li>
                                            </ul>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="p-4 pb-3 text-center feature-item why-cpc-item why-cpc-item1 doc-user">
                                <img
                                    src={manojSingh}
                                    alt="Icon"
                                    className="feature-icon mb-3"
                                />
                                <div className="feature-text">
                                    <b>Dr. Manoj Singh</b>
                                    <div className="text-start">
                                        <h6 className="about-us-team-sub-head text-center mb-2  mt-2">
                                            Senior Academic & Diagnostic Leadership
                                        </h6>
                                        <div className="mt-2">
                                            <ul className="team-list">
                                                <li className="fw-bold">MD (Pathology); FRCPath </li>
                                                <li className="fw-bold">Former Professor & Head, Department of Pathology, AIIMS </li>
                                                <li className="fw-bold">Former Director, Dermatopathology Laboratory, AIIMS </li>
                                                <li className="fw-bold">Consultant Dermatopathologist, Lifeline Laboratory & Agilus Diagnostic Network, Delhi </li>
                                            </ul>
                                        </div>
                                        <h6 className=" mb-2">
                                            Pioneer of dermatopathology in India with over three decades of academic leadership.
                                        </h6>
                                        <div>
                                            <ul className="team-list">
                                                <li>Instrumental in establishing organised dermatopathology services and training at AIIMS </li>
                                                <li>Recipient of the Dr. B. C. Roy National Award  </li>
                                                <li>Author of 130+ peer-reviewed publications </li>
                                                <li>National authority in dermatopathology education and quality assurance  </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>






                <section className=" mt-5 pb-5">
                    <div className="container justify-content-center">
                        <div className="text-center mb-4">
                            <h3>What to Expect?</h3>
                        </div>

                        <div className="row justify-content-center mt-5 gap-3 expect-cards-resp">
                            <div className="col-lg-2 col-md-2 col-sm-4 text-center d-grid align-items-center justify-content-center  gap-2 feature-item why-cpc-item1">
                                <div className="d-flex justify-content-center">
                                    <span className="material-symbols-outlined arrow">
                                        <img src={gobalLearning} width={26} alt="" />
                                    </span>
                                </div>
                                <div className="feature-text">
                                    <b>Case-Based Learning</b>
                                    <p className="mt-1 mb-0">Dive into real-world dermatopathology <br></br>  cases.</p>
                                </div>
                            </div>



                            <div className="col-lg-2 col-md-2 col-sm-4 text-center d-grid align-items-center justify-content-center gap-2 feature-item why-cpc-item1">
                                <div className="d-flex justify-content-center">
                                    <span className="material-symbols-outlined arrow">
                                        <img src={calendarEdit} width={26} alt="" />
                                    </span>
                                </div>
                                <div className="feature-text">
                                    <b>Engagement</b>
                                    <p className="mt-1 mb-0">Participate in live Q&As and quizzes with exciting <br></br> prizes.</p>
                                </div>
                            </div>

                            <div className="col-lg-2 col-md-2 col-sm-4 text-center d-grid align-items-center justify-content-center  gap-2 feature-item why-cpc-item1">
                                <div className="d-flex justify-content-center">
                                    <span className="material-symbols-outlined arrow">
                                        <img src={definitionSearch} width={26} alt="" />
                                    </span>
                                </div>
                                <div className="feature-text">
                                    <b>Flexibility</b>
                                    <p className="mt-1 mb-0">Learn at your own pace with free access to live <br></br> sessions.</p>
                                </div>
                            </div>

                            <div className="col-lg-2 col-md-2 col-sm-4 text-center d-grid align-items-center justify-content-center gap-2 feature-item why-cpc-item1">
                                <div className="d-flex justify-content-center">
                                    <span className="material-symbols-outlined arrow">
                                        <img src={groupMeeting} width={26} alt="" />
                                    </span>
                                </div>
                                <div className="feature-text">
                                    <b>Expert Insights</b>
                                    <p className="mt-1 mb-0">Gain practical knowledge from India’s top dermatopathologists.</p>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* <!-- Community Section --> */}
                    {/* <section className="community-banner text-center">
                        <div className="container">
                            <h3 className="fw-bold">Join hundreds of dermatologists at our inaugural CPC!</h3>
                            <p className="text-muted">Be part of a growing community advancing dermatopathology education across India.</p>
                        </div>
                    </section> */}
                </section>

                <section className="pt-5 pb-5 why-join join-free">
                    <div className="container d-grid align-items-center justify-content-center">
                        <div className="mb-2">
                            <h3 className="text-center">Join Us</h3>
                            <p>Follow us on <b className="join-date fw-semibold">YouTube</b> for updates!</p>
                        </div>
                        <div className="d-flex flex-wrap col-lg-12 justify-content-center gap-3 ms-0 ps-0">
                            <a className="register-link" href="https://youtube.com/playlist?list=PL1u1zcr-ZEXEStQwQaFdwhdDut6Y-b7NX&si=B0AKH6bO7d_UjH7h" target="_blank">
                                <button className="btn-fill-icon" onClick={handleClick}><span className="material-symbols-outlined btn-icon-fill-style">keyboard_arrow_right</span>YouTube </button>
                            </a>
                            <a>
                                <button className="btn-stroke-icon" onClick={handleEmail}><span className="material-symbols-outlined btn-icon-stroke-style">keyboard_arrow_right</span>Email Us</button>
                            </a>
                        </div>
                        {/* <div className="text-center mt-3 soical-icons-cpc">
                            <p className="text-muted">Follow us on <a href="https://youtube.com/playlist?list=PL1u1zcr-ZEXEStQwQaFdwhdDut6Y-b7NX&si=B0AKH6bO7d_UjH7h" target="_blank">YouTube</a> for updates!</p>
                        </div> */}
                    </div>
                </section>







                <section className="cpc-description-section py-5 d-none" id="pageContent">
                    <div className="container d-flex flex-column align-items-center text-center">
                        {/* <img src={errorImg} alt="CPC Coming Soon" className="img-fluid mb-4" style={{ maxWidth: "300px" }} /> */}
                        <h4 className="mb-3">CPC (Clinical-Pathological Correlation) Sessions</h4>
                        <p className="mb-4" style={{ maxWidth: "800px", lineHeight: "1.8", fontSize: "16px" }}>
                            Our CPC (Clinical-Pathological Correlation) sessions provide a unique learning opportunity for pathologists,
                            clinicians, and medical professionals. These interactive sessions enable in-depth discussions of real patient cases,
                            integrating clinical information with pathological findings to foster a holistic understanding of diagnosis and treatment.
                        </p>
                        <ul className="text-start" style={{ maxWidth: "800px", fontSize: "16px", lineHeight: "1.8" }}>
                            <li><strong>Collaborate with Experts:</strong> Join a community of medical professionals to discuss real cases and gain insights from leading experts in dermatopathology.</li>
                            <li><strong>Improve Diagnostic Skills:</strong> Engage in detailed analysis of clinical data and histopathological images, honing your ability to make accurate, informed diagnoses.</li>
                            <li><strong>Learn through Case-Based Discussions:</strong> Each CPC session is designed to challenge your thinking and expand your understanding of complex cases.</li>
                            <li><strong>Enhance Patient Care:</strong> Improve your ability to correlate clinical and pathological findings, contributing to better patient outcomes.</li>
                        </ul>
                    </div>
                </section>
                <div className="service-link d-none">
                    {/* <button className="btn-stroke-icon mt-5" onClick={(e) => handelnavigation3()}>

                                <p>Lecture Library</p></button>
                            <span className="material-symbols-outlined arrow_forward_fill">arrow_forward_ios</span> */}
                    <button className="btn-fill-icon mt-5" onClick={(e) => handelnavigation("Clinician")}><span className="material-symbols-outlined btn-icon-fill-style">
                        keyboard_arrow_right
                    </span>Lecture Library</button>
                    <button className="btn-fill-icon mt-5" onClick={(e) => handelnavigation("Student")}><span className="material-symbols-outlined btn-icon-fill-style">
                        keyboard_arrow_right
                    </span>CPC</button>
                </div>

            </div>


            <Footer />
        </>
    );
};

export default CpcRegistration;
